export const ALL_TAB = 'all';
export const NOMINATED_TAB = 'nominated';
export const ASSIGNED_TAB = 'assigned';
export const LIVE_CHAT_TAB = 'live_chat';
